export default __webpack_public_path__ + "static/media/chevron-down.019b32e0.svg";